//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import { cloneDeep, merge, isNumber } from 'lodash';
import SearchModeConfig from './searchModeConfig.vue';

const defaultForm = {
  name: '',
  description: '',
  data_source_type: 'upload',
  data_source_config: {
    object: '',
    name_field: '',
    data_field: '',
    meta_fields: [],
    sync_mode: 'auto',
    file_ext: '',
  },
  process_mode: 'auto',
  process_rules: {
    pre_processing_rules: ['remove_extra_spaces'],
    segmentation: {
      delimiter: '\\n',
      max_tokens: 500,
      chunk_overlap: 50,
    },
  },
  index_mode: 'hnsw',
  embedding_model: '',
  embedding_model_provider: '',
  search_mode: 'vector',
  reranking_enable: false,
  reranking_mode: 'reranking_model',
  reranking_model: {
    reranking_provider_name: '',
    reranking_model_name: '',
  },
  weights: {
    fulltext_setting: {
      fulltext_weight: 30,
    },
    vector_setting: {
      vector_weight: 70,
    },
  },
  top_k: 2,
  score_threshold_enabled: false,
  score_threshold: '',
};

function parseJson(str, defaultValue) {
  try {
    return JSON.parse(str);
  } catch (e) {
    return defaultValue;
  }
}

function numberValidator(rule, value, callback) {
  if (isNumber(value)) {
    callback();
  } else {
    callback('必须为数字');
  }
}

export default {
  name: 'EditAgentAppDetail',
  components: { Drawer, SearchModeConfig },
  props: {
    row: { type: Object, default: () => {} },
    type: { type: String, default: 'create' },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: cloneDeep(defaultForm),
      objectList: [],
      fieldList: [],
      rerankingModelList: [],
      textEmbeddingModelList: [],
      rules: {
        name: [{ required: true, message: '请输入知识库名称', trigger: 'blur' }],
        data_source_type: [{ required: true, message: '请选择数据源类型', trigger: 'change' }],
        'data_source_config.object': [
          { required: true, message: '请选择元数据对象', trigger: 'change' },
        ],
        'data_source_config.name_field': [
          { required: true, message: '请选择文档名称来源字段', trigger: 'change' },
        ],
        'data_source_config.data_field': [
          { required: true, message: '请选择文档数据来源字段', trigger: 'change' },
        ],
        'data_source_config.file_ext': [
          { required: true, message: '请选择内容格式', trigger: 'change' },
        ],
        process_mode: [{ required: true, message: '请选择文档处理模式', trigger: 'change' }],
        'process_rules.pre_processing_rules': [
          { required: true, message: '请选择预处理规则', trigger: 'change' },
        ],
        'process_rules.segmentation.delimiter': [
          { required: true, message: '请输入分段标志符', trigger: 'change' },
        ],
        'process_rules.segmentation.max_tokens': [
          { required: true, message: '请输入分段最大长度', trigger: 'change' },
          { validator: numberValidator, trigger: 'blur' },
        ],
        'process_rules.segmentation.chunk_overlap': [
          { required: true, message: '请输入分段重叠长度', trigger: 'change' },
          { validator: numberValidator, trigger: 'blur' },
        ],
        index_mode: [{ required: true, message: '请选择索引类型', trigger: 'change' }],
        embedding_model: [{ required: true, message: '请选择嵌入模型', trigger: 'change' }],
        search_mode: [{ required: true, message: '请选择检索模式', trigger: 'change' }],
        top_k: [
          { required: true, message: '请输入top k', trigger: 'blur' },
          { validator: numberValidator, trigger: 'blur' },
        ],
        'reranking_model.reranking_model_name': [
          { required: true, message: '请输入rerank模型', trigger: 'change' },
        ],
        score_threshold: [
          { required: true, message: '请输入score阈值', trigger: 'blur' },
          { validator: numberValidator, trigger: 'blur' },
        ],
      },
      slideMasks: {
        0: {
          style: {
            marginLeft: '20px',
          },
          label: '全文检索',
        },
        100: {
          style: {
            right: '-50px',
          },
          label: '语义',
        },
      },
    };
  },
  computed: {
    isEdit() {
      return this.type === 'edit';
    },
  },
  watch: {
    visible() {
      if (this.visible) {
        if (this.type === 'edit') {
          this.form = merge(cloneDeep(defaultForm), this.resetData(cloneDeep(this.row)));
          this.$nextTick(() => {
            this.$refs.config.setFormData(cloneDeep(this.row));
          });
        } else {
          this.form = cloneDeep(defaultForm);
          this.$nextTick(() => {
            this.$refs.config.setFormData();
          });
        }
        this.$nextTick(() => {
          this.$refs?.form?.clearValidate();
          this.getObjectList();
          this.getFieldList();
          this.getModels('rerank', 'rerankingModelList');
          this.getModels('text-embedding', 'textEmbeddingModelList');
        });
      }
    },
  },
  mounted() {},
  methods: {
    close() {
      this.$emit('close');
    },
    resetData(formData) {
      formData.data_source_config = parseJson(
        formData.data_source_config,
        cloneDeep(defaultForm.data_source_config),
      );
      formData.process_rules = parseJson(
        formData.process_rules,
        cloneDeep(defaultForm.process_rules),
      );
      return formData;
    },
    async getObjectList() {
      try {
        const { objects } = await this.$request({
          url: this.$api.metaGetObjectList,
          data: {
            limit: 99999,
            offset: 0,
            sort: 'create_time desc',
          },
        });
        this.objectList = objects;
      } catch (err) {
        console.log(err);
        this.objectList = [];
      }
    },

    objectChange() {
      this.$set(this.form.data_source_config, 'name_field', '');
      this.$set(this.form.data_source_config, 'data_field', '');
      this.$set(this.form.data_source_config, 'meta_fields', []);
      this.getFieldList();
      this.$nextTick(() => {
        this.$refs.form.clearValidate([
          'data_source_config.name_field',
          'data_source_config.data_field',
        ]);
      });
    },

    searchModeChange(v) {
      this.$set(this.form, 'reranking_enable', false);
      if (v === 'hybrid') {
        this.$set(this.form, 'reranking_mode', 'weighted_score');
      } else {
        this.$set(this.form, 'reranking_mode', 'reranking_model');
      }
    },
    rerankingModeChange(v) {
      if (v === 'weighted_score') {
        this.$set(this.form, 'reranking_enable', false);
      } else {
        this.$set(this.form, 'reranking_enable', true);
      }
    },

    async getFieldList() {
      if (!this.form?.data_source_config?.object) {
        return;
      }
      try {
        const { fields } = await this.$request({
          url: this.$api.metaGetObjectFields,
          data: {
            object: this.form.data_source_config.object,
          },
        });
        this.fieldList = fields;
      } catch (err) {
        console.log(err);
        this.fieldList = [];
      }
    },

    async getModels(modelType, key) {
      try {
        const { models } = await this.$request({
          url: this.$api.listDefaultModels,
          data: {
            model_type: modelType,
          },
        });
        this[key] = models;
      } catch (err) {
        console.log(err);
        this[key] = [];
      }
    },

    // 通过modelName获取providerName
    getModelsProvider(key, modelName) {
      const list = this[key] || [];
      return list.find((item) => item.model_name === modelName)?.provider_name || '';
    },
    validate(callback) {
      Promise.all([
        new Promise((resolve) => {
          this.$refs.form.validate((valid) => {
            resolve(valid);
          });
        }),
        new Promise((resolve) => {
          this.$refs.config.validate((valid) => {
            resolve(valid);
          });
        }),
      ]).then((res) => {
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', res[0], res[1]);
        callback(res[0] && res[1]);
      });
    },
    submitForm() {
      this.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          let formData = cloneDeep(this.form);
          if (formData.data_source_type === 'upload') {
            formData.data_source_config = undefined;
          } else {
            if (formData.data_source_type !== 'db-data') {
              formData.data_source_config.file_ext = undefined;
            }
            formData.data_source_config = JSON.stringify(formData.data_source_config);
          }
          formData.process_rules.segmentation.max_tokens = parseInt(
            formData.process_rules.segmentation.max_tokens,
          );
          formData.process_rules.segmentation.chunk_overlap = parseInt(
            formData.process_rules.segmentation.chunk_overlap,
          );
          formData.process_rules = JSON.stringify(formData.process_rules);
          if (formData.index_mode !== 'hnsw') {
            formData.embedding_model = '';
            formData.embedding_model_provider = '';
          } else {
            formData.embedding_model_provider = this.getModelsProvider(
              'textEmbeddingModelList',
              formData.embedding_model,
            );
          }
          formData = {
            ...formData,
            ...this.$refs.config.getFormData(),
          };
          this.$request({
            url: this.type === 'edit' ? this.$api.updateAgentDataset : this.$api.createAgentDataset,
            data:
              this.type === 'edit'
                ? {
                    id: formData.id,
                    dataset: formData,
                  }
                : formData,
          })
            .then((res) => {
              console.log('%c Line:154 🥕 res', 'color:#42b983', res);
              this.$emit('refresh');
              this.$message.success('保存成功');
              this.close();
            })
            .catch(() => {
              this.$message.error('保存失败');
            });
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
